export default "/dist/acura/static/media/acura_bespoke-regular.woff";